import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import axios from 'axios';
import { handleLocalStorage, routerJump, getTheme } from '@/assets/js/utils.js';
const CancelToken = axios.CancelToken;
export default {
  setup() {
    const {
      isDark
    } = getTheme();
    return {
      isDark
    };
  },
  data() {
    var _JSON$parse;
    return {
      isTruncated: {},
      talkbackStatus: false,
      initOperateData: null,
      index: '',
      isSelectMode: false,
      joinPartyCode: '',
      showSearch: false,
      partyListLoading: false,
      showSortPop: false,
      partyList: [],
      scroll: {
        distance: 20,
        onScroll: this.getPartyList
      },
      removeInfoTips: {
        title: 'arenaMode.deleteParty',
        content: '<div class="end">Are you sure you want to delete this party？</p></div>',
        cancel: 'commonFunction.cancel',
        save: 'tagName.del',
        show: false,
        class: 'delPartyDialog'
      },
      disablePartyInfo: {
        title: 'partyInfo.disableParty',
        cancel: 'galleryHost.cancel',
        save: 'kioskHost.yes',
        show: false
      },
      partyPageInfo: {
        pageNum: 1,
        pageSize: 20,
        hasNextPage: false
      },
      partyListUrl: {
        party: '/partyline-backend/party/page',
        group: '/partyline-backend/group/page',
        coordinator: '/partyline-backend/conference/page',
        kiosk: '/partyline-backend/kiosk/page',
        interview: '/partyline-backend/interview/page'
      },
      cancel: {
        party: null,
        group: null
      },
      env: handleLocalStorage('get', 'partylineConfig') ? (_JSON$parse = JSON.parse(handleLocalStorage('get', 'partylineConfig'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.apiEnv : '',
      array: [{
        url: [require('@/assets/img/partyline.png'), require('@/assets/img/partylineDark.png')],
        label: 'partyline',
        detail: 'partylineDetail'
      }, {
        url: [require('@/assets/img/Galleryview.png'), require('@/assets/img/GalleryviewDark.png')],
        label: 'GalleryView',
        detail: 'GalleryViewDetail'
      }, {
        url: [require('@/assets/img/Conference.png'), require('@/assets/img/ConferenceDark.png')],
        label: 'conference',
        detail: 'conferenceDetail'
      }, {
        url: [require('@/assets/img/Kiosk.png'), require('@/assets/img/KioskDark.png')],
        label: 'kiosk',
        detail: 'kioskDetail'
      }, {
        url: [require('@/assets/img/Globalcontrol.png'), require('@/assets/img/GlobalcontrolDark.png')],
        label: 'globalControl',
        detail: 'globalControlDetail'
      }],
      partyInfoList: [{
        label: 'createTime',
        icon: 'icon-Pending'
      }, {
        label: 'partyID',
        icon: 'icon-partyID'
      }, {
        label: 'host',
        icon: 'icon-renyuan-05'
      }, {
        label: 'cohost',
        icon: 'icon-renyuan-05'
      }],
      selectPartyInfo: {},
      createPartyInfo: {
        party: '/partyline-backend/party/create',
        group: '/partyline-backend/group/create',
        coordinator: '/partyline-backend/conference/create',
        kiosk: '/partyline-backend/kiosk/create',
        interview: '/partyline-backend/interview/create'
      },
      requestInfo: {
        party: '/partyline-backend/commonParty/updateTitle',
        group: '/partyline-backend/group/updateTitle',
        coordinator: '/partyline-backend/conference/updateTitle',
        kiosk: '/partyline-backend/kiosk/updateTitle',
        interview: '/partyline-backend/interview/updateTitle'
      },
      joinPartyInfo: {
        show: false,
        title: 'common.tvuPartyLine',
        save: 'start.join',
        hideCancel: true
      },
      sortValue: {
        label: '',
        value: '',
        order: ''
      },
      sortList: [{
        label: 'date',
        value: 'createTime',
        order: 'desc'
      }, {
        label: 'name',
        value: 'title',
        order: 'asc'
      }],
      searchInfo: '',
      settingPopupInfo: {
        show: false
      },
      isHost: true,
      editPass: false,
      showErrorPassCode: false,
      inviteInfo: {
        show: false,
        title: 'invite.getLink',
        save: 'invite.saveInvite',
        hideCancel: true,
        hideSave: true
      },
      deleteInfo: {
        item: '',
        index: ''
      },
      timer: null,
      deletePartyObj: {
        party: {
          methods: this.axios.post,
          url: '/partyline-backend/party/delete',
          params: {
            idList: [],
            _partyCode43232: ''
          }
        },
        group: {
          methods: this.axios.delete,
          url: '/partyline-backend/group/'
        },
        coordinator: {
          methods: this.axios.post,
          url: '/partyline-backend/conference/delete/'
        },
        kiosk: {
          methods: this.axios.delete,
          url: '/partyline-backend/kiosk/'
        },
        interview: {
          methods: this.axios.delete,
          url: '/partyline-backend/interview/'
        }
      },
      // co-host 定义变量开始
      coHostInfo: {
        show: false,
        title: 'commonPartyHost.leftPane.partyOperation.AddCoHost',
        save: 'invite.saveInvite',
        hideBottom: true,
        hideSave: true
      },
      cohostPageInfo: {
        pageNum: 1,
        pageSize: 5,
        hasNextPage: false
      },
      receiveCoHostInfo: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      coHostSearchName: '',
      showErrorEmailText: false,
      willInviteCohost: [],
      hadInviteUserColor: ['green', 'orange', 'purple', 'blue'],
      hadInviteCohost: [],
      hadAllInviteCohost: [],
      inputTimer: 0,
      cohostScroll: {
        distance: 10,
        onScroll: this.getCoHostHadInvite
      },
      receivedCohost: {
        show: false,
        title: 'commonPartyHost.leftPane.partyOperation.ReceiverCoHost',
        hideSave: true,
        hideBottom: true
      },
      receiverCohostPageInfo: {
        pageNum: 1,
        pageSize: 10,
        hasNextPage: false
      },
      invitedMeList: [],
      receiverCohostScroll: {
        distance: 10,
        onScroll: this.getInvitedByOhter,
        directive: '.invitedMe .el-table__body-wrapper'
      },
      options: [{
        value: '1',
        label: 'accept'
      }, {
        value: '2',
        label: 'decline'
      }],
      // co-host 定义变量结束
      channelMode: {
        party: 0,
        group: 1,
        coordinator: 2,
        kiosk: 13
      },
      historyList: [],
      historyInfo: {
        pageNum: 1,
        pageSize: 20,
        hasNextPage: true
      },
      historyListScroll: {
        distance: 10,
        onScroll: this.getHistoryList
      },
      maxPip: 0,
      initMaxPip: 0,
      partyStatus: {},
      disableInfo: {}
    };
  },
  props: {
    currentModule: {
      type: String,
      default: 'party'
    }
  },
  computed: {
    ...mapState({
      State: state => state,
      Config: state => state.config,
      loginInfo: state => state.loginInfo,
      joinLink: state => {
        var _state$config$urlInfo;
        return (_state$config$urlInfo = state.config.urlInfo) === null || _state$config$urlInfo === void 0 ? void 0 : _state$config$urlInfo.joinLink;
      }
    }),
    returnDisClass() {
      return this.partyStatus.enable ? 'grayColor' : 'redColor';
    },
    showMeanContent() {
      return this.partyStatus.enable ? this.$t('partyInfo.disableMean') : this.$t('partyInfo.enableMena');
    },
    showConfrimText() {
      return this.partyStatus.enable ? this.$t('partyInfo.disableConfrimText') : this.$t('partyInfo.enableConfrimText');
    }
  },
  watch: {
    currentModule(val, oldVal) {
      this.isSelectMode = false;
      this.historyList = [];
      this.historyInfo.pageNum = 1;
      this.historyInfo.pageSize = 20;
      this.historyInfo.hasNextPage = true;
      this.partyPageInfo.pageNum = 1;
      this.partyPageInfo.pageSize = 20;
      this.selectPartyInfo = {};
      this.partyStatus = {};
      this.disableInfo = {};
      this.partyListLoading = false;
      if (val === 'party') {
        this.partyInfoList = [{
          label: 'createTime',
          icon: 'icon-Pending'
        }, {
          label: 'partyID',
          icon: 'icon-partyID'
        }, {
          label: 'host',
          icon: 'icon-renyuan-05'
        }, {
          label: 'cohost',
          icon: 'icon-renyuan-05'
        }];
      } else {
        this.partyInfoList = this.partyInfoList.filter(item => {
          return item.label != 'cohost';
        });
      }
      if (oldVal) {
        this.cancel[oldVal] && this.cancel[oldVal]();
      }
      this.getPartyList('init');
    },
    'State.checkEnv': {
      handler(newVal) {
        if (newVal.owner) {
          this.isHost = true;
        } else {
          this.isHost = false;
        }
      }
    },
    'State.receivedCohost': {
      handler(newVal) {
        if (newVal == true) {
          this.receivedCohost.show = true;
        }
      }
    },
    'selectPartyInfo.code': {
      handler(partyCode) {
        if (partyCode) {
          this.historyInfo.pageNum = 1;
          this.historyInfo.pageSize = 20;
          this.historyInfo.hasNextPage = true;
          const code = this.currentModule === 'group' ? this.selectPartyInfo.externalOutputParty : partyCode;
          this.getHistoryList(code, 'init');
        } else {
          this.historyList = [];
        }
      }
    }
  },
  created() {
    this.getPartyList('init');
    Bus.$on('collaborateInvite', result => {
      const {
        collaborateUserId,
        status,
        toEmail,
        PartyCode
      } = result;
      if (PartyCode) {
        // co-host页面
        if (collaborateUserId == this.State.loginInfo.id) {
          status === 0 ? this.receiveCoHostInfo.show = true : this.receiveCoHostInfo.show = false;
          if (status === 0) {
            this.receiveCoHostInfo.info = result;
          } else if (status === 1) {
            this.getPartyList('init');
          } else if (status === 2) {
            this.receiveCoHostInfo.info = {};
          }
        } else {
          // host页面
          if (status === 1) {
            this.$message.success(toEmail + this.$t('personalInfo.accepted'));
            this.partyList.forEach(partyInfo => {
              if (partyInfo.partyCode === PartyCode) {
                partyInfo.coHost = 1;
              }
            });
          } else if (status === 2) {
            this.partyList.forEach(partyInfo => {
              if (partyInfo.partyCode === PartyCode) {
                partyInfo.coHost = 0;
              }
            });
            this.$message.warning(toEmail + this.$t('personalInfo.refuseInvite'));
          }
        }
      }
    });
    Bus.$on('deleteCollaborateInvite', result => {
      const {
        actionUserEmail,
        deletedUserEmail,
        PartyCode
      } = result;
      if (deletedUserEmail === this.loginInfo.email) {
        this.receiveCoHostInfo.show = false;
        this.$message.warning(actionUserEmail + this.$t('personalInfo.hostRemoveInvited'));
        this.partyList = this.partyList.filter(item => {
          return item.partyCode != PartyCode;
        });
      }
    });
  },
  mounted() {
    setInterval(this.callLoginInfo, 3600000);
  },
  methods: {
    checkTruncated(index) {
      this.$nextTick(() => {
        const refName = `truncatedText_${index}`;
        const el = this.$refs[refName];
        const targetEl = Array.isArray(el) ? el[0] : el;
        if (targetEl) {
          // 检测实际高度是否超过容器高度（考虑3行）
          const isOverflow = targetEl.scrollHeight > targetEl.clientHeight;
          this.$set(this.isTruncated, index, isOverflow);
        }
      });
    },
    callLoginInfo() {
      this.$store.dispatch('isLogin');
    },
    controlCohostInvite(val) {
      const params = {
        collaborateLogId: this.receiveCoHostInfo.info.collaborateLogId,
        optionType: val ? 1 : 2
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (params.optionType == 1) {
            this.$message.success(this.$t('personalInfo.acceptHostSuccess'));
            // 重新渲染列表
            this.partyPageInfo.pageNum = 1;
            this.getPartyList('init');
          } else {
            this.$message.success(this.$t('personalInfo.acceptHostCancel'));
          }
        } else if (res.data.errorCode == '82203101') {
          this.$message.warning(this.$t('common.invitedExpire'));
        }
      });
    },
    getSettingStatus(item) {
      item.loading = true;
      this.axios.get(`/partyline-backend/party/noLogin/partyStatus/${this.State.partyCode}`).then(res => {
        if (!res) return;
        const result = res.data.result;
        if (res.data.errorCode === '0x0') {
          this.partyStatus = result;
          this.talkbackStatus = result.talkBack === 'true';
          this.maxPip = result.maxParticipantCount;
          this.initMaxPip = result.maxParticipantCount;
          if (this.currentModule === 'group') {
            item.externalOutputParty = result.externalOutputParty + '';
            this.selectPartyInfo = item;
          }
          Bus.$emit('initOperateData', res.data.result);
          Bus.$emit('getInitStatus', {
            videoQuality: result.videoQuality || 'low',
            talkBack: this.talkbackStatus,
            cloudProxy: result.cloudProxy === 'true'
          });
        }
        item.loading = false;
      });
    },
    openPreviewPage(item) {
      return window.location.href.replace('manage', 'preview') + `?id=${item.code}`;
    },
    async createParty() {
      const url = this.createPartyInfo[this.currentModule];
      const params = this.currentModule == 'party' ? {
        type: 2,
        appType: 10
      } : {
        title: ''
      };
      await this.axios.post(url, params).then(async res => {
        if (res.data.errorCode === '0x0') {
          this.$message({
            type: 'success',
            message: this.$t('startNewParty.createSuccessful')
          });
          // 获取正在进行中的会议列表
          this.partyPageInfo.pageNum = 1;
          this.getPartyList('init', 'create');
          gtag('event', 'Create party', {
            event_category: '创见会议',
            event_label: '会议模块',
            value: this.currentModule
          });
        }
      });
    },
    sortPartyList(item) {
      this.sortValue = item;
      this.getPartyList('init');
    },
    getPartyList(init, create) {
      // 判断各种需要跳出去的条件
      const canLoadNextPage = this.loadNextPage(init);
      if (!canLoadNextPage) return;
      this.partyListLoading = true;
      // 如果init没有则是滚动加载进来的页数要加1
      if (!init) {
        this.partyPageInfo.pageNum++;
      } else {
        this.partyPageInfo.pageNum = 1;
      }
      const params = {
        pageSize: this.partyPageInfo.pageSize,
        pageNum: this.partyPageInfo.pageNum,
        sortField: this.sortValue.value,
        sortDirection: this.sortValue.order
      };
      const self = this;
      this.axios.post(self.partyListUrl[self.currentModule], params, {
        cancelToken: new CancelToken(function executor(c) {
          self.cancel[self.currentModule] = c;
          self.$emit('callback', self.cancel);
          // 这个参数 c 就是CancelToken构造函数里面自带的取消请求的函数，这里把该函数当参数用
        })
      }).then(res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          const list = result.list;
          const sortField = result.info.sortField;
          if (list && list.length) {
            list.forEach(v => {
              v.visible = false;
              v.edit = false;
              v.editName = '';
              v.redTip = false;
              v.redMessage = '';
              v.loading = false;
            });
          }
          this.sortList.forEach(item => {
            if (item.value == sortField) {
              this.sortValue = item;
            }
          });
          this.partyPageInfo.hasNextPage = result.hasNextPage;
          this.partyListLoading = false;
          if (!init) {
            this.partyList = this.partyList.concat(list);
          } else {
            this.partyList = list;
          }
          // 创建的时候默认选择刚创建好的
          if (create) {
            this.selectPartyInfo = this.partyList[0];
          }
        }
      }).catch(e => {
        console.log(e);
      });
    },
    loadNextPage(init) {
      let flag = true;
      if (this.partyListLoading || !init && !this.partyPageInfo.hasNextPage) {
        flag = false;
      }
      return flag;
    },
    showTitle(item) {
      if (item.title) return item.title;
      return new Date(item.startPartyTime || item.createTime).toLocaleDateString() + '   ' + new Date(item.startPartyTime || item.createTime).toLocaleTimeString();
    },
    rename(index, type) {
      const obj = JSON.parse(JSON.stringify(this.partyList[index])); // copy一份避免重写被原来的值给覆盖
      obj.edit = type === 'blur' ? false : !obj.edit;
      obj.editName = obj.title || new Date(obj.createTime).toLocaleDateString() + '   ' + new Date(obj.createTime).toLocaleTimeString();
      obj.redTip = false;
      obj.redMessage = '';
      this.$set(this.partyList, index, obj);
      if (!obj.edit) return;
      this.$nextTick(() => {
        // 自动获取焦点 element组件autofocus失效
        this.$refs[`input${index}`][0].$refs.input.focus();
        this.$refs[`input${index}`][0].$refs.input.select();
      });
      this.hidePopup(obj, index);
      gtag('event', 'rename', {
        event_category: 'click',
        event_label: '会议重命名'
      });
    },
    saveName(index) {
      const obj = this.partyList[index];
      if (!obj.editName || !obj.editName.trim()) {
        obj.redTip = false;
        obj.edit = !obj.edit;
        this.$set(this.partyList, index, obj);
        return;
      }
      // 成功
      this.axios.post(this.requestInfo[this.currentModule], {
        id: obj.id,
        title: obj.editName,
        _partyCode: this.State.partyCode,
        partyCode: this.State.partyCode
      }, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('copy.rename'));
          obj.title = obj.editName;
          obj.redTip = false;
          obj.edit = !obj.edit;
          this.selectPartyInfo.title = obj.editName;
        } else {
          // 失败
          obj.redTip = true;
          obj.redMessage = res.data.errorInfo;
        }
        this.$set(this.partyList, index, obj);
      }).catch(() => {
        // 失败
        obj.redTip = true;
        this.$set(this.partyList, index, obj);
      });
    },
    hidePopup(item, index, copyLink) {
      item.visible = false;
      this.$set(this.partyList, index, item);
      if (copyLink) {
        this.$copyText(this.copyParty(item)).then(this.onCopy).catch(this.onError);
      }
    },
    copyParty(item) {
      const domain = window.location.host;
      gtag('event', 'copy link', {
        event_category: 'click',
        event_label: '复制会议连接'
      });
      return 'https://' + domain + '/partyline?join_id=' + item.code + `${this.env ? '&env=' + this.env : ''}`;
    },
    onCopy() {
      this.$message({
        message: this.$t('copy.onCopy'),
        type: 'success'
      });
    },
    onError() {
      this.$message({
        message: this.$t('copy.onError'),
        type: 'error'
      });
    },
    showAddCoHost(item, index) {
      this.coHostInfo.show = true;
      if (this.partyList[index]) {
        this.partyList[index].visible = false;
      }
      gtag('event', 'show coHost', {
        event_category: 'click',
        event_label: '显示协作人员名单'
      });
    },
    quitCoHost(item, index) {
      const params = {
        partyCode: this.State.partyCode
      };
      this.axios.post('/partyline-backend/collaborate/cancel', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.partyList.splice(index, 1);
        }
      });
    },
    deleteParty(item, index, fromInfo) {
      if (fromInfo) {
        this.partyList.forEach((info, number) => {
          if (info.code == item.code) {
            this.deleteInfo.index = number;
          }
        });
      } else {
        this.deleteInfo.index = index;
        this.partyList[index].visible = false;
      }
      this.deleteInfo.item = item;
      this.removeInfoTips.content = `<div class="end">${this.$t('addWords.sureDelParty')}</div>`;
      this.removeInfoTips.show = true;
    },
    savePartyInfo(val) {
      this.isSelectMode = true;
      if (this.currentModule != 'group') {
        this.selectPartyInfo = val;
      }
      this.State.partyCode = val.code;
      this.getSettingStatus(val);
      if (this.currentModule === 'party') this.getCoHostHadInvite('init', true);
    },
    getHistoryList(partyCode, init) {
      if (!init && !this.historyInfo.hasNextPage) return;
      if (!this.Config.urlInfo) return;
      if (!init) this.historyInfo.pageNum++;
      let params = {};
      if (this.currentModule === 'group') {
        params = {
          operationName: null,
          variables: {
            page: this.historyInfo.pageNum,
            pageSize: this.historyInfo.pageSize,
            email: this.loginInfo.email,
            cname: partyCode || this.selectPartyInfo.code,
            channelMode: this.channelMode[this.currentModule]
          },
          query: 'query ($pageSize: Int!, $page: Int, $startTime: String, $endTime: String, $email: String, $title: String, $partyCode: String, $channelMode: String, $cname: String) {\n  partylineListPartyStatus(\n    page: $page\n    pageSize: $pageSize\n    startTime: $startTime\n    endTime: $endTime\n    email: $email\n    title: $title\n    partyCode: $partyCode\n  channelMode: $channelMode\n cname: $cname\n) {\n    edges {\n      node {\n        id\n        email\n        title\n        partyCode\n        channelMode\n        cname\n        createdTs\n        destroyedTs\n        status\n        maxCurrentParticipantNum\n        hostUserId\n        maxParticipantNum\n        __typename\n      }\n      __typename\n    }\n    pageInfo {\n      totalPages\n      currentPage\n      totalNum\n      pageSize\n      __typename\n    }\n    __typename\n  }\n}\n'
        };
      } else {
        params = {
          operationName: null,
          variables: {
            page: this.historyInfo.pageNum,
            pageSize: this.historyInfo.pageSize,
            email: this.loginInfo.email,
            partyCode: partyCode || this.selectPartyInfo.code,
            channelMode: this.channelMode[this.currentModule]
          },
          query: 'query ($pageSize: Int!, $page: Int, $startTime: String, $endTime: String, $email: String, $title: String, $partyCode: String, $channelMode: String) {\n  partylineListPartyStatus(\n    page: $page\n    pageSize: $pageSize\n    startTime: $startTime\n    endTime: $endTime\n    email: $email\n    title: $title\n    partyCode: $partyCode\n  channelMode: $channelMode\n) {\n    edges {\n      node {\n        id\n        email\n        title\n        partyCode\n        channelMode\n        cname\n        createdTs\n        destroyedTs\n        status\n        maxCurrentParticipantNum\n        hostUserId\n        maxParticipantNum\n        __typename\n      }\n      __typename\n    }\n    pageInfo {\n      totalPages\n      currentPage\n      totalNum\n      pageSize\n      __typename\n    }\n    __typename\n  }\n}\n'
        };
      }
      const url = location.protocol + '//' + this.Config.urlInfo.gatewayUrl + '/usage-service/graphql';
      this.axios.post(url, params).then(res => {
        var _res$data, _res$data$data;
        if (!res) return;
        const result = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.partylineListPartyStatus;
        this.historyInfo.hasNextPage = result.pageInfo.totalNum - this.historyInfo.pageSize * this.historyInfo.pageNum > 0;
        if (init) {
          this.historyList = result.edges;
        } else {
          this.historyList = this.historyList.concat(result.edges);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    returnContent(item, type) {
      if (JSON.stringify(item) != '{}') {
        if (type === 'createTime') {
          return new Date(item.startPartyTime || item.createTime).toLocaleDateString().replaceAll('/', '-') + '   ' + new Date(item.startPartyTime || item.createTime).toLocaleTimeString() + '  (Web)';
        } else if (type === 'partyID') {
          return this.$options.filters.returnStrByInfo(item.code, item.code ? item.code.length === 9 ? 3 : 4 : 4);
        } else if (type === 'host') {
          return this.State.loginInfo.email;
        } else {
          let cohostString = '';
          this.hadAllInviteCohost.forEach(item => {
            if (item.status === 1) {
              cohostString += item.collaborateEmail + ' , ';
            }
          });
          return cohostString.slice(0, -3);
        }
      } else {
        return '';
      }
    },
    returnPartyID(code) {
      return this.$options.filters.returnStrByInfo(code, code.length === 9 ? 3 : 4);
    },
    showHistoryTime(type, key, item) {
      const startPartyTime = Number(item.node.createdTs) * 1000;
      const endPartyTime = Number(item.node.destroyedTs) ? Number(item.node.destroyedTs) * 1000 : new Date().getTime();
      const duration = endPartyTime - startPartyTime;
      const oneDay = 24 * 60 * 60 * 1000;
      const oneHours = 60 * 60 * 1000;
      const oneMinute = 60 * 1000;
      if (type === 'year') {
        return new Date(startPartyTime).toLocaleDateString().replaceAll('/', '-');
      } else if (type === 'hours') {
        //  如果会议持续时间超过一天则显示年月,一天毫秒 = 24 * 60 * 60 * 1000
        if (duration - oneDay > 0) {
          return key === 'start' ? new Date(startPartyTime).toLocaleDateString().replaceAll('/', '-') + '   ' + new Date(startPartyTime).toLocaleTimeString() : new Date(endPartyTime).toLocaleDateString().replaceAll('/', '-') + '   ' + new Date(endPartyTime).toLocaleTimeString();
        } else {
          const index = key === 'start' ? new Date(startPartyTime).toLocaleTimeString().lastIndexOf(':') : new Date(endPartyTime).toLocaleTimeString().lastIndexOf(':');
          return key === 'start' ? new Date(startPartyTime).toLocaleTimeString().slice(0, index) : new Date(endPartyTime).toLocaleTimeString().slice(0, index);
        }
      } else {
        //  如果会议持续时间超过一天则显示年月,一天毫秒 = 24 * 60 * 60 * 1000
        if (duration - oneDay > 0) {
          const day = parseInt(duration / oneDay);
          const hours = parseInt((duration - oneDay * day) / oneHours);
          const minutes = parseInt((duration - oneDay * day - hours * oneHours) / oneMinute);
          return day + ' day' + ' ' + hours + ' hour' + ' ' + minutes + ' minutes';
        } else if (duration - oneHours > 0) {
          const hours = parseInt(duration / oneHours);
          const minutes = parseInt((duration - hours * oneHours) / oneMinute);
          return parseInt(duration / oneHours) + ' hour' + ' ' + minutes + ' minutes';
        } else if (duration - oneMinute > 0) {
          return ((endPartyTime - startPartyTime) / 1000 / 60).toFixed(0) + ' minutes';
        } else {
          return (endPartyTime - startPartyTime) / 1000 + ' seconds';
        }
      }
    },
    joinParty() {
      const url = this.joinPartyCode.replace(/\s+/g, '');
      const isCommentator = url.includes('commentator');
      let id = null;
      if (isNaN(Number(url))) {
        if (url.indexOf('join_id') > -1) {
          if (url.indexOf('PartyID:') > -1) {
            id = url.split('PartyID:')[1];
          } else {
            id = this.getQueryString(url, 'join_id');
          }
        } else {
          id = this.getQueryString(url, 'id');
        }
      } else {
        id = url;
      }
      if (!id) {
        this.$message.error(this.$t('remainWords.enterId'));
        return;
      }
      sessionStorage.removeItem('enterPartyType');
      const query = {
        join_id: id,
        env: this.Config.apiEnv,
        type: isCommentator ? 'commentator' : ''
      };
      routerJump('participate', query);
    },
    getQueryString(url, name) {
      let value = null;
      url = url.split('?')[1];
      if (url) {
        url = url.split('&');
        url.forEach(v => {
          const keysValue = v.split('=');
          if (keysValue[0] == name) {
            value = keysValue[1];
          }
        });
      }
      return value;
    },
    showSettingPopup(item, index, fromInfo) {
      if (!fromInfo) this.hidePopup(item, index);
      this.settingPopupInfo.show = true;
      this.State.partyJoinInfo = item;
      gtag('event', 'show setting', {
        event_category: 'click',
        event_label: '显示视频相关设置弹框'
      });
    },
    closeSettingDialog() {
      this.settingPopupInfo.show = false;
    },
    showInvited(item, index, fromInfo) {
      if (!fromInfo) this.hidePopup(item, index);
      this.inviteInfo.show = true;
      gtag('event', 'invited', {
        event_category: 'click',
        event_label: '显示邀请列表'
      });
    },
    // ---- co-host 相关代码开始 ----
    // 打开弹窗后数据加载
    getCoHostList() {
      this.coHostInfo.hideSave = true;
      this.getCoHostHadInvite('init');
    },
    // 打开弹窗后数据加载
    async getCoHostHadInvite(init, getAllCoHost) {
      if (!init && !this.cohostPageInfo.hasNextPage) return;
      // 如果init没有则是滚动加载进来的页数要加1
      if (!init) this.cohostPageInfo.pageNum++;
      // 清空之前的状态
      this.coHostSearchName = '';
      this.showErrorEmailText = false;
      this.willInviteCohost = [];
      const params = {
        invite: true,
        partyCode: this.selectPartyInfo.code,
        queryCollaborate: false,
        pageSize: getAllCoHost ? 50 : this.cohostPageInfo.pageSize,
        pageNum: this.cohostPageInfo.pageNum
      };
      await this.axios.post('/partyline-backend/collaborate/queryV2', params).then(res => {
        if (!res) return;
        const {
          errorCode,
          result
        } = res.data;
        if (errorCode === '0x0') {
          this.cohostPageInfo.hasNextPage = result.hasNextPage;
          result.list.forEach((info, index) => {
            if (index < 3) {
              info.color = this.returnColor(info);
            }
          });
          if (!init) {
            this.hadInviteCohost = this.hadInviteCohost.concat(result.list);
            this.State.hadInvitedCoHostList = this.hadInviteCohost.concat(JSON.parse(JSON.stringify(result.list)));
          } else {
            this.hadInviteCohost = this.hadAllInviteCohost = result.list;
            this.State.hadInvitedCoHostList = JSON.parse(JSON.stringify(result.list));
          }
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    returnColor(info) {
      const {
        status
      } = info;
      if (status === 0 || status === 2) {
        return 'gray';
      } else if (status === 1) {
        return this.hadInviteUserColor[info.collaborateEmail.length % 4] || 'green';
      }
    },
    closeCohost() {
      this.cohostPageInfo.pageNum = 1;
    },
    // co-host点击保存
    saveCoHost(email) {
      if (!this.coHostSearchName) {
        this.$message.warning(this.$t('personalInfo.noInvitedEmail'));
        this.coHostInfo.show = true;
        return false;
      }
      if (!this.isEmail(this.coHostSearchName)) return;
      if (this.coHostSearchName === this.State.loginInfo.email) {
        this.$message.warning(this.$t('personalInfo.forbidSetting'));
        return;
      }
      if (this.isHadInvited(this.coHostSearchName)) return;
      const params = {
        collaborateUserEmailList: [this.coHostSearchName],
        partyCode: this.State.partyCode
      };
      this.axios.post('/partyline-backend/collaborate', params, {
        errorTip: false
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          if (email && this.coHostSearchName && this.isEmail(this.coHostSearchName) && !this.isHadInvited(this.coHostSearchName)) {
            const obj = {};
            obj.name = this.coHostSearchName;
            obj.color = 'gray';
            this.willInviteCohost.push(obj);
          }
          this.willInviteCohost = [...new Set(this.willInviteCohost)];
          this.coHostSearchName = '';
          this.getCoHostHadInvite();
          this.$message.success(this.$t('personalInfo.hostSaveSuccess'));
        } else if (errorCode === '9000002') {
          this.$message.warning(this.$t('personalInfo.forbidSetting'));
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      });
    },
    isEmail(val) {
      var regEmail = /^([a-zA-Z0-9_\-\.])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (val && !regEmail.test(val)) {
        this.showErrorEmailText = true;
        this.$refs.emailInput.$el.children[0].focus();
        return false;
      }
      return true;
    },
    // 判断是否已经存在于列表中
    isHadInvited(email) {
      let flag = false;
      this.willInviteCohost.forEach(item => {
        if (item.name == email) {
          flag = true;
        }
      });
      this.hadInviteCohost.forEach(info => {
        if (info.collaborateEmail == email && info.status != 2) {
          flag = true;
        }
      });
      if (flag) {
        this.$message.warning(this.$t('personalInfo.hadInvited'));
      }
      return flag;
    },
    // input格式校验
    checkInputText(val) {
      if (new Date().getTime() - this.inputTimer < 1500) return;
      this.inputTimer = new Date().getTime();
      var regEmail = /^([a-zA-Z0-9_\-\.])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (val && !regEmail.test(val)) {
        this.showErrorEmailText = true;
        this.$refs.emailInput.$el.children[0].focus();
      } else {
        this.showErrorEmailText = false;
      }
    },
    removeCoHostInvite(index) {
      this.willInviteCohost.splice(index, 1);
    },
    deleteCohostInvite(userId, index) {
      const params = {
        userIds: [userId],
        partyCode: this.selectPartyInfo.code
      };
      this.axios.delete('/partyline-backend/collaborate', {
        data: params
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          if (this.cohostPageInfo.pageNum == 1 && this.cohostPageInfo.hasNextPage) {
            this.getCoHostHadInvite('init');
          } else {
            this.hadInviteCohost.splice(index, 1);
            this.State.hadInvitedCoHostList.splice(index, 1);
          }
          // this.hadInvite.splice(index, 1) cohost不需要
          this.$message.success(this.$t('invite.inviteDeleteSuccess'));
          this.getPartyList('init', 'firstParty');
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      });
    },
    showReceivedPop() {
      this.coHostInfo.show = false;
      this.receivedCohost.show = true;
    },
    // 打开cohost受邀弹窗
    getReceiverCoHostList() {
      this.getInvitedByOther('init');
    },
    getInvitedByOther(init) {
      if (!init && !this.receiverCohostPageInfo.hasNextPage) return;
      // 如果init没有则是滚动加载进来的页数要加1
      if (!init) this.receiverCohostPageInfo.pageNum++;
      const params = {
        invite: false,
        queryCollaborate: false,
        pageSize: this.receiverCohostPageInfo.pageSize,
        pageNum: this.receiverCohostPageInfo.pageNum
      };
      this.axios.post('/partyline-backend/collaborate/queryV2', params).then(res => {
        if (!res) return;
        const {
          errorCode,
          result
        } = res.data;
        if (errorCode === '0x0') {
          this.receiverCohostPageInfo.hasNextPage = result.hasNextPage;
          if (!init) {
            this.invitedMeList = this.invitedMeList.concat(result.list);
          } else {
            this.invitedMeList = result.list;
          }
          result.list.forEach(item => {
            item.select = '';
            item.color = this.returnColor(item);
          });
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    closeReceivedCohost() {
      this.State.receivedCohost = false;
      this.receiverCohostPageInfo.pageNum = 1;
    },
    showInvitedTime(invitedTime) {
      const year = new Date(invitedTime).getFullYear();
      let month = new Date(invitedTime).getMonth() + 1;
      let date = new Date(invitedTime).getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (date < 10) {
        date = '0' + date;
      }
      return year + '-' + month + '-' + date;
    },
    returnText(rowInfo) {
      let _str = '';
      if (rowInfo.status == 0) {
        _str = this.$t('personalInfo.inviting');
      } else if (rowInfo.status == 1) {
        _str = this.$t('personalInfo.accept');
      } else {
        _str = this.$t('personalInfo.declined');
      }
      return _str;
    },
    controlPermission(val, rowInfo) {
      const params = {
        collaborateId: rowInfo.id,
        optionType: Number(val)
      };
      this.axios.post(`/partyline-backend/collaborate/updateStatusDirectly?collaborateId=${params.collaborateId}&optionType=${params.optionType}`, params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.invitedMeList.forEach(item => {
            if (item.id == rowInfo.id) {
              item.status = params.optionType;
              item.color = this.returnColor({
                status: params.optionType,
                collaborateEmail: item.userEmail
              });
            }
          });
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    deleteCollaborateByOtherInvite(rowInfo) {
      const params = {
        userIds: [rowInfo.userId],
        invite: false,
        partyCode: rowInfo.partyCode
      };
      this.axios.delete('/partyline-backend/collaborate', {
        data: params
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          if (this.receiverCohostPageInfo.pageNum == 1 && this.receiverCohostPageInfo.hasNextPage) {
            this.getInvitedByOther('init');
          } else {
            this.invitedMeList.forEach((item, index) => {
              if (item.id == rowInfo.id) {
                this.invitedMeList.splice(index, 1);
              }
            });
          }
          this.getPartyList('init', 'firstParty');
          this.$message.success(this.$t('invite.inviteDeleteSuccess'));
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      });
    },
    // --- co-host 相关代码结束 ----
    async onSureDeleteParty(item, index) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        let url = '';
        if (this.currentModule === 'party') {
          url = this.deletePartyObj[this.currentModule].url;
          this.deletePartyObj.party.params.idList = [Number(item.id)];
          this.deletePartyObj.party.params._partyCode43232 = item.partyCode || item.code;
        } else if (this.currentModule === 'group') {
          url = this.deletePartyObj[this.currentModule].url + item.groupIdStr;
          if (!item.groupIdStr) return;
        } else if (this.currentModule === 'interview') {
          url = `${this.deletePartyObj[this.currentModule].url}${item.partyCode}`;
        } else {
          url = `${this.deletePartyObj[this.currentModule].url}${item.id}?_partyCode43232=${item.partyCode ? item.partyCode : item.code}`;
          if (!item.id) return;
        }
        await this.deletePartyObj[this.currentModule].methods(url, this.deletePartyObj[this.currentModule].params).then(res => {
          if (res.data.errorCode === '0x0') {
            this.$message({
              message: this.$t('deleteParty.delS'),
              type: 'success'
            });
            item.visible = false;
            if (this.partyPageInfo.pageNum == 1 && this.partyPageInfo.hasNextPage) {
              this.getPartyList('init');
            } else {
              this.partyList.splice(index, 1);
            }
            // 如果删除的是当前选择的则清空数据
            if (item.code == this.selectPartyInfo.code) {
              this.selectPartyInfo = {};
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.errorInfo
            });
          }
        });
      }, 1000);
    },
    savePipLimit() {
      if (!this.selectPartyInfo.code) return;
      const regex = /^\d+$/;
      if (!regex.test(this.maxPip)) {
        this.$message.warning(this.$t('partyInfo.inputNumber'));
        return;
      }
      if (isNaN(Number(this.maxPip))) {
        this.$message.warning(this.$t('partyInfo.inputNumber'));
        return;
      }
      this.axios.post(`/partyline-backend/partyAction/setMaxParticipantCount?partyCode=${this.selectPartyInfo.code}`, {
        maxParticipantCount: this.maxPip
      }, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.initMaxPip = this.maxPip;
          this.$message.success(this.$t('galleryHost.operationS'));
        } else {
          this.maxPip = this.initMaxPip;
          if (res.data.errorCode === '80520114') {
            this.$message.warning(this.$t('partyInfo.modifyMaxPip'));
          }
        }
      });
    },
    selectVal(event) {
      event.currentTarget.select();
    },
    showDisablePop(item) {
      item.visible = false;
      this.disableInfo = item;
      this.disablePartyInfo.title = this.partyStatus.enable ? 'partyInfo.disableParty' : 'partyInfo.enableParty';
      this.disablePartyInfo.show = true;
    },
    setDisableParty() {
      const params = {
        buttonType: 11,
        operationType: Number(!this.partyStatus.enable)
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.selectPartyInfo.code}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.partyStatus.enable = params.operationType;
          if (this.disableInfo.partyBasicStatus) {
            this.disableInfo.partyBasicStatus.enable = params.operationType;
          }
          this.$message.success(this.$t('setting.audioBackOperateSuccess'));
        }
      });
    }
  }
};